import { render, staticRenderFns } from "./AuditLogHistory.vue?vue&type=template&id=2779823e&scoped=true"
import script from "./AuditLogHistory.vue?vue&type=script&lang=ts"
export * from "./AuditLogHistory.vue?vue&type=script&lang=ts"
import style0 from "./AuditLogHistory.vue?vue&type=style&index=0&id=2779823e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2779823e",
  null
  
)

export default component.exports